import { Injectable } from '@angular/core';
import { NoticeContent } from 'src/app/shared/interfaces/notification-center.interface';

@Injectable({
  providedIn: 'root',
})
export class RightAsideService {
  /** 订阅 右边活动弹窗的下表 */
  combinePopupIndex!: number;

  /** 消息缓存 */
  allNoticeCache: {
    list: NoticeContent[];
    total: number;
  } = {
    list: [],
    total: 0,
  };

  set setCombinePopupIndex(value: number) {
    this.combinePopupIndex = value;
  }

  get getCombinePopupIndex(): number {
    return this.combinePopupIndex;
  }
}
